import React from 'react';
import Player from '../components/Player';
import { usePlayer } from '../context/PlayerContext';
import HomeHero from './home/HomeHero';
import HomeMarquee from './home/HomeMarquee';
import HomeStats from './home/HomeStats';
import HomeCards from './home/HomeCards';

export default function Home() {
  const { nowPlaying } = usePlayer();
  const alexaLive = process.env.REACT_APP_ALEXA_LIVE === 'true';

  return (
    <section className="w-full flex flex-col items-center justify-center text-center fade-up">
      <HomeHero alexaLive={alexaLive} />
      <HomeMarquee song={nowPlaying.song} />
      <div className="mt-14 w-full">
        <Player size="lg" />
      </div>
      <HomeStats listeners={nowPlaying.listeners} bitrate={nowPlaying.bitrate} />
      <div className="ascii-divider my-12">·  ·  ·  ·  ·</div>
      <HomeCards />
    </section>
  );
}
